import { TComment } from "src/components/common/comments-area/comment/comment.types";
import { mapInfiniteQueryPages } from "src/components/common/comments-area/utils/map-infinite-query-pages";

type TData = {
    pageParams: undefined[];
    pages: {
        comments: TComment[];
        commentsCount: number;
    }[];
};
type TCreateNewPagesBasedOnReply = {
    data: TData;
    newComment: TComment;
};

/**
 * The function essentially handles the addition of a new comment within a paginated structure
 * and ensures the proper updating of reply in comments.
 */
export const createNewPagesBasedOnReply = ({ data, newComment }: TCreateNewPagesBasedOnReply) => {
    const { rootCommentId, parentCommentId } = newComment;
    const pages = data.pages;

    const addNewReplyToCurrentPage = (comments: TComment[]) => {
        const indexOfReplied = comments.findIndex(comment => comment.commentId === parentCommentId);
        if (indexOfReplied !== -1) {
            return [...comments.slice(0, indexOfReplied + 1), newComment, ...comments.slice(indexOfReplied + 1)];
        }
        return comments;
    };

    if (rootCommentId === parentCommentId) {
        const [firstPage, ...restPages] = pages;
        const updatedFirstPage = { comments: [newComment, ...firstPage.comments], commentsCount: pages[0].commentsCount };
        return {
            pages: [updatedFirstPage, ...restPages],
            pageParams: data.pageParams,
        };
    }

    return {
        pages: mapInfiniteQueryPages({ pages, callback: addNewReplyToCurrentPage }),
        pageParams: data.pageParams,
    };
};
